const AvailableStartDate = Object.freeze({
  EARLIEST: 'EARLIEST',
  LESS_THAN_6_MONTH: 'LESS_THAN_6_MONTH',
  MORE_THAN_6_MONTH: 'MORE_THAN_6_MONTH',
  DEPENDING_ON_OFFER: 'DEPENDING_ON_OFFER',
  DEPENDING_ON_SALE: 'DEPENDING_ON_SALE'
})

export default AvailableStartDate
